export function toLowercaseHyphes(str) {
  return str.toLowerCase().trim().replace(/\s/g,'-');
}